module.exports = __webpack_public_path__ + "static/img/bg1.418d0bc6.png";